module.exports = __webpack_public_path__ + "static/media/plumber.6e4dbe51.jpg";